import { MainCardsType } from "@/types/landing-page";
import CreateChallengeCard from "../components/CreateChallenge";
import CreateCircleCard from "../components/createCircleCard";
import Sadaqahcard from "../components/sadaqahCard";
import { FC } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const LandingCards: FC<{
  isContentLoading: boolean;
  content?: MainCardsType;
}> = ({ isContentLoading, content }) => {
  return (
    <section className="flex flex-col gap-6 px-6 lg:flex-row">
      <CreateChallengeCard image={content?.create_challenge.image}>
        {isContentLoading ? (
          <div className="mb-6 flex w-full flex-col items-center justify-start gap-4">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
        ) : (
          <>
            <h3 className="mb-4 text-2xl font-650 leading-[120%] md:text-4xl">
              {content?.create_challenge.title || "Create a Challenge"}
            </h3>
            <p className="mb-6 max-w-[600px] text-lg font-350 leading-[140%] md:text-2xl md:leading-8">
              {content?.create_challenge.description ||
                "Set a donation goal and invite others to help you reach it."}
            </p>
          </>
        )}
      </CreateChallengeCard>
      <CreateCircleCard image={content?.start_giving_circle.image}>
        {isContentLoading ? (
          <div className="mb-6 flex w-full flex-col items-center justify-start gap-4">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
        ) : (
          <>
            <h3 className="mb-4 text-2xl font-650 leading-[120%] md:text-4xl">
              {content?.start_giving_circle.title || "Start a Giving Circle"}
            </h3>
            <p className="mb-6 max-w-[600px] text-lg font-350 leading-[140%] md:text-2xl md:leading-8">
              {content?.start_giving_circle.description ||
                "Join forces with friends, family, or colleagues to create your own donation Circle."}
            </p>
          </>
        )}
      </CreateCircleCard>
      <Sadaqahcard image={content?.create_sadaqah_jariyah.image}>
        {isContentLoading ? (
          <div className="mb-6 flex w-full flex-col items-center justify-start gap-4">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
        ) : (
          <>
            <h3 className="mb-4 text-2xl font-650 leading-[120%] md:text-4xl">
              {content?.create_sadaqah_jariyah.title || "Create a Sadaqah Jariyah"}
            </h3>
            <p className="mb-6 max-w-[600px] text-lg font-350 leading-[140%] md:text-2xl md:leading-8">
              {content?.create_sadaqah_jariyah.description ||
                "Honor someone you love donate in their memory and multiply the reward."}
            </p>
          </>
        )}
      </Sadaqahcard>
    </section>
  );
};

export default LandingCards;
